import React from 'react';
import ChatList from './ChatList';
import SearchBar from './SearchBar';
import PushToggle from './PushToggle';

const NAV = [
  { id: 'chat', icon: '◈', label: 'Chat' },
  { id: 'jobs', icon: '⊕', label: 'Recherche' },
  { id: 'ideas', icon: '💡', label: 'Ideen' },
  { id: 'wissen', icon: '🧠', label: 'Wissen' },
  { id: 'posting', icon: '📤', label: 'Posting' },
];

export default function Sidebar({ tab, setTab, onLogout, chatListProps, theme, setTheme, authToken, onSearchSelectChat, api, onHelp }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-logo-frame">
          <img src="/ako2me-logo.png" alt="AKO2ME" className="sidebar-logo" />
        </div>
      </div>

      <nav className="sidebar-nav">
        {NAV.map(n => (
          <button
            key={n.id}
            className={`nav-item ${tab === n.id ? 'active' : ''}`}
            onClick={() => setTab(n.id)}
            title={n.label}
          >
            <span className="nav-icon">{n.icon}</span>
            <span className="nav-label">{n.label}</span>
          </button>
        ))}
      </nav>

      {tab === 'chat' && authToken && (
        <SearchBar authToken={authToken} onSelectChat={onSearchSelectChat} />
      )}

      {tab === 'chat' && chatListProps && <ChatList {...chatListProps} />}

      {api && <PushToggle api={api} />}

      {setTheme && (
        <div className="theme-toggle">
          <button className={theme === 'light' ? 'active' : ''} onClick={() => setTheme('light')} title="Helles Theme">☀ Hell</button>
          <button className={theme === 'dark'  ? 'active' : ''} onClick={() => setTheme('dark')}  title="Dunkles Theme">☾ Dunkel</button>
        </div>
      )}

      <div className="sidebar-footer">
        {onHelp && (
          <button className="nav-item nav-item-muted" onClick={() => onHelp(null)}
            title="Hilfe & Benutzerhandbuch öffnen — mit Suche über alle Funktionen">
            <span className="nav-icon">❓</span>
            <span className="nav-label">Hilfe</span>
          </button>
        )}
        <button className="nav-item nav-item-muted" onClick={onLogout} title="Abmelden">
          <span className="nav-icon">⎋</span>
          <span className="nav-label">Abmelden</span>
        </button>
      </div>
    </aside>
  );
}
